import { render, staticRenderFns } from "./split-input.vue?vue&type=template&id=7dd6c6c0&"
import script from "./split-input.vue?vue&type=script&lang=js&"
export * from "./split-input.vue?vue&type=script&lang=js&"
import style0 from "./split-input.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports